import React, { useState, useEffect, useRef } from "react";
import back_arrow from "../../assets/svg/back-arrow.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import "../../styles/invoice_addnew.css";
import { X } from 'lucide-react';
import { useNavigate, useLocation } from "react-router-dom";
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import info_icon from "../../assets/svg/info_icon.svg";
import download_arrow from "../../assets/svg/download_arrow.svg";
import Invoice_header from '../Header/Invoice_header'
import axios from "axios";
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from "../../axiosInstance";
import CreateJobs from "./CreateJobs";
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";
import GenerateInvoiceHeader from "./GenerateInvoiceHeader";
import AsyncSelect from "react-select/async";
import { components } from 'react-select';
import CommonFooter from "../../CommonFooter/CommonFooter";
import useAttachmentValidator from "../AttachmentValidator/AttachmentValidator";
import VendorInvoicePopup from "./VendorInvoicePopup";
import { SquarePen } from "lucide-react";
import CommonRemarkPopup from "../../CommonRemarkPopup/CommonRemarkPopup";

const GenerateCostInvoice = () => {

  let ModuleId = 24
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);

  console.log("permission", permission);
  const { hasAdditionalPermission } = usePermissions();

  const [invoices, setInvoices] = useState("");
  const [expandedInvoice, setExpandedInvoice] = useState(null);
  const { validateAttachments } = useAttachmentValidator();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState([]);
  const [jobInputValue, setJobInputValue] = useState('');
  const [selectedJobOptions, setSelectedJobOptions] = useState([]);
  const [selectedJobIds, setSelectedJobIds] = useState([]);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [summary, setSummary] = useState([]);
  const [initialSelectedJobs, setInitialSelectedJobs] = useState([]);
  const [lineitems, setLineitems] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [vendorInvNumber, setVendorInvNumber] = useState("");
  const [vendorInvDate, setVendorInvDate] = useState("");
  const [projectId, setselectedprojectId] = useState(0);
  const [selectedChargeIds, setSelectedChargeIds] = useState({});
  const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
  const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [showaddPopup, setShowAddPopup] = useState(false);
  const [showCreateJobPopup, setShowCreateJobPopup] = useState(false);
  const [newlyCreatedJobs, setNewlyCreatedJobs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [invoiceRemarks, setInvoiceRemarks] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [vendorSuggestions, setVendorSuggestions] = useState([]);
  const [showVendorSuggestions, setShowVendorSuggestions] = useState({});
  const [vendorInputValues, setVendorInputValues] = useState({});
  const [selectedVendorIds, setSelectedVendorIds] = useState({});
  const [vendorAttachment, setVendorAttachment] = useState(null);
  const [vendorDetails, setVendorDetails] = useState([]);
  const [selectedVendorIdArray, setSelectedVendorIdArray] = useState([]);
  const [invoiceMode, setInvoiceMode] = useState("");
  const [selectedTaxCode, setSelectedTaxCode] = useState(null);
  const [taxInputValue, setTaxInputValue] = useState("");
  const [popupAction, setPopupAction] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [jobLevelInvoice, setJobLevelInvoice] = useState({});
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const [remarkMeta, setRemarkMeta] = useState(null);
  const [ffPlantCode, setFfPlantCode] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const calculateCategoryTotals = (category) => {
    const totals = {
      costAccrual: 0,
      costNetTotal: 0
    };

    category.rows.forEach(row => {
      totals.costAccrual += parseFloat(row.costAccrual) || 0;
      totals.costNetTotal += parseFloat(row.costNetTotal) || 0;
    });

    return totals;
  };

  const location = useLocation();
  const getErrorKey = (v, c, r, field) => `${v}_${c}_${r}_${field}`;
  const [vendorsData, setVendorsData] = useState([]);

  useEffect(() => {
    if (location.state?.billData) {
      const billData = location.state.billData;
      let selected_job_id = location.state.selectedBills;

      setSelectedJobId(selected_job_id);
      setProjectName(billData.vendors[0]?.summary[0]?.project_name || "");
      setFfPlantCode(
        billData?.vendors?.[0]?.line_items?.[0]?.details?.[0]?.ff_plant_id ||  billData?.vendors?.[0]?.line_items?.[0]?.ff_plant_id|| null
      );
      setInvoiceMode(billData?.cost_invoice_type || "");
      // Initialize charge codes and vendor data
      const chargeIdMap = {};
      const vendorIdMap = {};
      const vendorNameMap = {};
      const inputValueMap = {};

      const processedVendors = billData.vendors.map((vendor, vendorIndex) => {
        return {
          ...vendor,
          existing_vendor_attachment: vendor.existing_vendor_attachment || [],
          categories: vendor.line_items.map((job, categoryIndex) => {
            const rows = job.details.map((detail, rowIndex) => {
              const key = `${vendorIndex}_${categoryIndex}_${rowIndex}`;

              // Map charge codes
              chargeIdMap[key] = detail.charge_id;
              inputValueMap[key] = detail.charge_code || "";

              // Map vendor data
              vendorIdMap[key] = detail.vendor_id;
              vendorNameMap[key] = detail.vendor_name || "";

              return {
                billingtype: "",
                elements: "",
                project_id: detail.project_id,
                costRemarks: detail.cost_remarks,
                division_type: detail.job_type_division?.toLowerCase(),
                chargecode: detail.charge_code,
                jobIds: detail.job_id,
                jobTypeId: detail.job_type_id,
                jobLineId: detail.job_cost_line_id,
                description: detail.description,
                po_wo_number: detail.cost_po_wo_number || null,
                po_wo_date: detail.cost_po_wo_date || null,
                vendor_inv_number: detail.vendor_inv_number || "",
                vendor_inv_date: detail.vendor_inv_date || null,
                costunitQuantity: detail.cost_unit_of_quantity,
                costRate: detail.cost_unit_of_rate,
                costNetTotal: detail.cost_net_total,
                costContractValue: detail.cost_contract_value,
                costAccrual: detail.cost_accrual,
                attachment: detail.attachment_url || "",
                existingAttachmentUrl: detail.attachment_url || "",
                uploadedFiles: [],
                isChecked: true,
                supporting_document: detail.cost_supporting_doc ?? false,
                existingVendorAttachmentUrl: detail.vendor_invoice_attachment_url || "",
              };
            });

            const totals = calculateCategoryTotals({ rows });

            return {
              id: job.job_no,
              job_id: job.details[0]?.job_id || null,
              costAccrual: totals.costAccrual,
              costNetTotal: totals.costNetTotal,
              contract_id: job.contract_id,
              name: `Job Number-${job.job_no}`,
              jobNo: job.job_no,
              rate: 1000,
              rows: rows,
              isChecked: true,
            };
          })
        };
      });

      // Set all the mapped data
      setSelectedChargeIds(chargeIdMap);
      setSelectedVendorIds(vendorIdMap);
      setVendorInputValues(vendorNameMap);
      setInputValues(inputValueMap);

      setVendorsData(processedVendors);
      setSummary(billData.vendors.flatMap(vendor => vendor.summary));
      setselectedprojectId(billData.vendors[0]?.summary[0]?.project_id || 0);
    }
  }, [location.state]);


  // Initialize state with the received jobs
  // useEffect(() => {
  //   if (lineitems.length > 0) {
  //     const categories = lineitems.map(job => {
  //       console.log(
  //         `Job No: ${job.job_no} | contract_id: ${job.contract_id}`
  //       );
  //       const rows = job.details.map(detail => ({
  //         billingtype: "",
  //         elements: "",
  //         costRemarks: detail.cost_remarks,
  //         chargecode: detail.charge_code,
  //         jobIds: detail.job_id,
  //         jobTypeId: detail.job_type_id,
  //         jobLineId: detail.job_line_id,
  //         description: detail.description,
  //         // unitQuantity: detail.unit_of_quantity,
  //         costunitQuantity: detail.cost_unit_of_quantity,
  //         costRate: detail.cost_unit_of_rate, // From response
  //         costNetTotal: detail.cost_net_total, // From response
  //         costAccrual: detail.cost_accrual, // From response  

  //         costContractValue: detail.cost_contract_value,

  //         // accrualSplit: detail.accrual,
  //         attachment: detail.attachment_url || "",
  //         existingAttachmentUrl: detail.attachment_url || "",
  //         uploadedFiles: [],
  //         isChecked: true,
  //         supporting_document: detail.cost_supporting_doc ?? false,
  //       }));
  //       const totals = calculateCategoryTotals({ rows });
  //       return {
  //         id: job.job_no,
  //         job_id: job.details[0]?.job_id || null,
  //         // accrual: Number(job.accrual).toFixed(2),
  //          costAccrual: totals.costAccrual,
  //          costNetTotal: totals.costNetTotal,
  //         contract_id: job.contract_id,
  //         name: `Job Number-${job.job_no}`,
  //         jobNo: job.job_no,
  //         rate: 1000,
  //         rows: rows,
  //         isChecked: true,
  //       };
  //     });

  //     console.log("categories initial check from api", categories);


  //     setAllCategories(categories);

  //     // ➕ Populate inputValues here
  //     const initialInputValues = {};
  //     categories.forEach((category, catIndex) => {
  //       initialInputValues[catIndex] = {};
  //       category.rows.forEach((row, rowIndex) => {
  //         initialInputValues[catIndex][rowIndex] = row.chargecode || "";
  //       });
  //     });
  //     setInputValues(initialInputValues);

  //   }
  // }, [lineitems]);


  // When selected jobs change, update the categories
  useEffect(() => {
    // Create categories directly from the selectedJobs in state
    const newCategories = selectedJobs.map(jobId => {
      // Find the job in the initial selected jobs from location state
      const job = initialSelectedJobs.find(j => j.jobNo === jobId);

      return {
        id: job?.jobNo || jobId,
        jobId: job?.job_id || 0,
        name: `Job-${job?.jobNo || jobId}`,
        // quantity: job ? parseInt(job.projectCost.replace(/\D/g, '')) / 1000 || 0 : 0,
        rate: 1000, // Default rate or calculate as needed
        // netValue: job ? parseInt(job.projectCost.replace(/\D/g, '')) || 0 : 0,
        rows: [{
          billingtype: "",
          jobTypeId: "",
          jobLineId: "",
          chargecode: "",
          elements: "",
          remarks: "",
          description: job?.project || "",
          po_wo_number: null,
          po_wo_date: null,
          // unitQuantity: "",
          costunitQuantity: "",
          costRemarks: "",
          costRate: "",
          costNetTotal: "",
          costContractValue: "0.00",
          costAccrual: "",
          attachment: "",
          existingAttachmentUrl: job?.attachment_url || "",
          uploadedFiles: [],
          isChecked: true,
          contract_id: null,
        }]
      };
    });

    setAllCategories(newCategories);
  }, [selectedJobs]);

  // const handleJobSelection = (e) => {
  //   const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
  //   setSelectedJobs(selectedOptions);
  // };


  // const handleRemoveJob = async (jobIdToRemove) => {
  //   const confirmed = window.confirm("Are you sure you want to remove this job?");
  //   if (!confirmed) return;

  //   console.log("Existing job id", selectedJobId);
  //   console.log("Trying to remove:", jobIdToRemove);

  //   const updatedJobs = selectedJobId.filter(jobId => Number(jobId) !== Number(jobIdToRemove));
  //   console.log("After removed job id", updatedJobs);

  //   setSelectedJobs(updatedJobs);

  //   try {
  //     const invoicePayload = { job_ids: updatedJobs };
  //     const invoiceResponse = await axiosInstance.post('/job/generate_invoice', invoicePayload);

  //     if (invoiceResponse.data.success) {
  //       navigate("/invoice_addNew", {
  //         state: {
  //           billData: invoiceResponse.data,
  //           selectedJobs: updatedJobs
  //         }
  //       });
  //     } else {
  //       toast.error("Failed to regenerate invoice data");
  //     }
  //   } catch (error) {
  //     console.error("Error regenerating invoice:", error);
  //     toast.error(error.response?.data?.message || "Invoice regeneration failed");
  //   }
  // };





  const handleAttachFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles([...uploadedFiles, ...files]);
  };

  const handleAttachRemoveFile = (index) => {
    const newFiles = [...uploadedFiles];
    newFiles.splice(index, 1);
    setUploadedFiles(newFiles);
  };

  const addRow = (vendorIndex, categoryId) => {
    setVendorsData(prevVendors =>
      prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        const updatedCategories = vendor.categories.map(category => {
          if (category.id !== categoryId) return category;

          console.log("categoryyyyyyy add new row", category);

          return {
            ...category,
            rows: [
              ...category.rows,
              {
                billingtype: "",
                jobTypeId: category.rows[0]?.jobTypeId || "",
                chargecode: "",
                elements: "",
                description: "",
                costunitQuantity: "",
                costRemarks: "",
                costRate: "",
                costNetTotal: "",
                costContractValue: "0.00",
                costAccrual: "",
                po_wo_number: null,
                po_wo_date: null,
                attachment: "",
                uploadedFiles: [],
                isChecked: true,
                vendor_inv_number: "",
                vendor_inv_date: "",
                contract_id: null,
                supporting_document: false,
                jobIds: category.job_id,
                project_id: category.rows[0]?.project_id || "",
                division_type: category.rows[0]?.division_type || "",
              }
            ]
          };
        });

        return {
          ...vendor,
          categories: updatedCategories
        };
      })
    );
  };

  const handleFileUpload = (e, vendorIndex, categoryId, rowIndex) => {
    const files = validateAttachments(e.target.files);
    if (!files.length) return;

    setVendorsData(prevVendors =>
      prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        return {
          ...vendor,
          categories: vendor.categories.map(category => {
            if (category.id !== categoryId) return category;

            return {
              ...category,
              rows: category.rows.map((row, rIndex) => {
                if (rIndex !== rowIndex) return row;

                return {
                  ...row,
                  uploadedFiles: [...(row.uploadedFiles || []), ...files]
                };
              })
            };
          })
        };
      })
    );
  };

  const handleRemoveFile = (vendorIndex, categoryId, rowIndex, fileIndex) => {
    setVendorsData(prevVendors =>
      prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        return {
          ...vendor,
          categories: vendor.categories.map(category => {
            if (category.id !== categoryId) return category;

            return {
              ...category,
              rows: category.rows.map((row, rIndex) => {
                if (rIndex !== rowIndex) return row;

                return {
                  ...row,
                  uploadedFiles: row.uploadedFiles.filter((_, idx) => idx !== fileIndex)
                };
              })
            };
          })
        };
      })
    );
  };

  // const handleInputChange = (e, index, rowIndex, field) => {
  //   const { value } = e.target;

  //   setAllCategories(prevCategories =>
  //     prevCategories.map((category, currentindex) =>
  //       currentindex === index
  //         ? {
  //           ...category,
  //           rows: category.rows.map((row, i) => {
  //             if (i === rowIndex) {
  //               const updatedRow = { ...row, [field]: value };

  //               if (field === 'unitQuantity' || field === 'unitRatePrice') {
  //                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
  //                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
  //                 updatedRow.netTotal = (quantity * rate).toString();
  //               }

  //               return updatedRow;
  //             }
  //             return row;
  //           }),
  //         }
  //         : category
  //     )
  //   );
  // };


  // const handleInputChange = (e, categoryId, rowIndex, field) => {
  //   const { value } = e.target;

  //   setAllCategories(prevCategories =>
  //     prevCategories.map(category =>
  //       category.id === categoryId
  //         ? {
  //           ...category,
  //           rows: category.rows.map((row, i) => {
  //             if (i === rowIndex) {
  //               const updatedRow = { ...row, [field]: value };

  //               if (field === 'unitQuantity' || field === 'unitRatePrice') {
  //                 const quantity = parseFloat(updatedRow.unitQuantity) || 0;
  //                 const rate = parseFloat(updatedRow.unitRatePrice) || 0;
  //                 updatedRow.netTotal = (quantity * rate).toString();
  //               }

  //               return updatedRow;
  //             }
  //             return row;
  //           }),
  //         }
  //         : category
  //     )
  //   );
  // };


  const handleInputChange = (e, vendorIndex, categoryIndex, rowIndex, field) => {
    let value = e.target.value;

    if (field === "costRemarks") {
      value = value.replace(/,/g, "");
    }

    setVendorsData(prevData =>
      prevData.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        const updatedCategories = vendor.categories.map((category, cIndex) => {
          if (cIndex !== categoryIndex) return category;

          const updatedRows = category.rows.map((row, rIndex) => {
            if (rIndex !== rowIndex) return row;

            const updatedRow = { ...row, [field]: value };

            // Recalculate values if quantity or rate changes
            if (field === 'salesunitQuantity' || field === 'costRate') {
              const quantity = parseFloat(updatedRow.salesunitQuantity) || 0;
              const rate = parseFloat(updatedRow.costRate) || 0;
              updatedRow.costNetTotal = (quantity * rate).toFixed(2);
            }

            if (field === 'costunitQuantity' || field === 'costRate') {
              const quantity = parseFloat(updatedRow.costunitQuantity) || 0;
              const rate = parseFloat(updatedRow.costRate) || 0;
              updatedRow.costNetTotal = (quantity * rate).toFixed(2);
            }

            // Profit calculation
            if (
              ['costRate', 'costunitQuantity', 'costNetTotal'].includes(field)
            ) {
              const salesTotal = parseFloat(updatedRow.costNetTotal) || 0;
              const costTotal = parseFloat(updatedRow.costNetTotal) || 0;
              updatedRow.profitAmount = (salesTotal - costTotal).toFixed(2);
              updatedRow.profitPercent = costTotal > 0
                ? (((salesTotal - costTotal) / costTotal) * 100).toFixed(2)
                : '0.00';
            }

            return updatedRow;
          });

          // Update category totals
          const totals = updatedRows.reduce((acc, row) => {
            const cost = parseFloat(row.costNetTotal) || 0;
            const profit = parseFloat(row.profitAmount) || 0;
            return {
              costNetTotal: acc.costNetTotal + cost,
              profitAmount: acc.profitAmount + profit,
            };
          }, { costNetTotal: 0, profitAmount: 0 });

          const profitPercent = totals.costNetTotal > 0
            ? ((totals.profitAmount / totals.costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...category,
            rows: updatedRows,
            costNetTotal: totals.costNetTotal.toFixed(2),
            profitAmount: totals.profitAmount.toFixed(2),
            profitPercent
          };
        });

        return {
          ...vendor,
          categories: updatedCategories
        };
      })
    );
  };

  const handleCheckboxChange = (e, vendorIndex, categoryId, rowIndex) => {
    const isChecked = e.target.checked;

    setVendorsData(prevVendors =>
      prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        const updatedCategories = vendor.categories.map(category => {
          if (category.id !== categoryId) return category;

          const updatedRows = category.rows.map((row, rIndex) =>
            rIndex === rowIndex ? { ...row, isChecked } : row
          );

          const allRowsChecked = updatedRows.every(row => row.isChecked);

          return {
            ...category,
            rows: updatedRows,
            isChecked: allRowsChecked
          };
        });

        const allCategoriesChecked = updatedCategories.every(cat => cat.isChecked);
        if (document.getElementById('selectAll')) {
          document.getElementById('selectAll').checked = allCategoriesChecked;
        }

        return {
          ...vendor,
          categories: updatedCategories
        };
      })
    );
  };

  // const deleteRow = (categoryId, rowIndex) => {
  //   setAllCategories(prevCategories =>
  //     prevCategories.map(category => {
  //       if (category.id === categoryId) {
  //         const newRows = [...category.rows];
  //         newRows.splice(rowIndex, 1);
  //         return { ...category, rows: newRows };
  //       }
  //       return category;
  //     })
  //   );
  // };

  const deleteRow = (vendorIndex, categoryId, rowIndex) => {
    // First check if deletion should be prevented
    const shouldPreventDelete = vendorsData[vendorIndex]?.categories?.some(
      category => category.id === categoryId && category.rows.length <= 1
    );

    if (shouldPreventDelete) {
      toast.error("At least one row must remain, cannot delete.");
      return; // Exit early if we shouldn't delete
    }

    // If we get here, it's safe to delete the row
    setVendorsData(prevVendors => {
      return prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        const updatedCategories = vendor.categories.map(category => {
          if (category.id === categoryId) {
            const newRows = [...category.rows];
            newRows.splice(rowIndex, 1);
            return {
              ...category,
              rows: newRows
            };
          }
          return category;
        });

        return {
          ...vendor,
          categories: updatedCategories
        };
      });
    });

    // Update other related states only if deletion was allowed
    setInputValues(prev => {
      const newInputValues = { ...prev };
      Object.keys(newInputValues).forEach(key => {
        const [vIdx, cIndex, rIndex] = key.split('_').map(Number);
        const category = vendorsData[vIdx]?.categories[cIndex];

        if (vIdx === vendorIndex && category?.id === categoryId) {
          if (rIndex === rowIndex) {
            delete newInputValues[key];
          } else if (rIndex > rowIndex) {
            const newKey = `${vIdx}_${cIndex}_${rIndex - 1}`;
            newInputValues[newKey] = newInputValues[key];
            delete newInputValues[key];
          }
        }
      });
      return newInputValues;
    });

    setSelectedChargeIds(prev => {
      const newSelectedChargeIds = { ...prev };
      Object.keys(newSelectedChargeIds).forEach(key => {
        const [vIdx, cIndex, rIndex] = key.split('_').map(Number);
        const category = vendorsData[vIdx]?.categories[cIndex];

        if (vIdx === vendorIndex && category?.id === categoryId) {
          if (rIndex === rowIndex) {
            delete newSelectedChargeIds[key];
          } else if (rIndex > rowIndex) {
            const newKey = `${vIdx}_${cIndex}_${rIndex - 1}`;
            newSelectedChargeIds[newKey] = newSelectedChargeIds[key];
            delete newSelectedChargeIds[key];
          }
        }
      });
      return newSelectedChargeIds;
    });

    setSelectedVendorIds(prev => {
      const newSelectedVendorIds = { ...prev };
      Object.keys(newSelectedVendorIds).forEach(key => {
        const [vIdx, cIndex, rIndex] = key.split('_').map(Number);
        const category = vendorsData[vIdx]?.categories[cIndex];

        if (vIdx === vendorIndex && category?.id === categoryId) {
          if (rIndex === rowIndex) {
            delete newSelectedVendorIds[key];
          } else if (rIndex > rowIndex) {
            const newKey = `${vIdx}_${cIndex}_${rIndex - 1}`;
            newSelectedVendorIds[newKey] = newSelectedVendorIds[key];
            delete newSelectedVendorIds[key];
          }
        }
      });
      return newSelectedVendorIds;
    });

    setVendorInputValues(prev => {
      const newVendorInputValues = { ...prev };
      Object.keys(newVendorInputValues).forEach(key => {
        const [vIdx, cIndex, rIndex] = key.split('_').map(Number);
        const category = vendorsData[vIdx]?.categories[cIndex];

        if (vIdx === vendorIndex && category?.id === categoryId) {
          if (rIndex === rowIndex) {
            delete newVendorInputValues[key];
          } else if (rIndex > rowIndex) {
            const newKey = `${vIdx}_${cIndex}_${rIndex - 1}`;
            newVendorInputValues[newKey] = newVendorInputValues[key];
            delete newVendorInputValues[key];
          }
        }
      });
      return newVendorInputValues;
    });

    setSuggestionsMap(prev => {
      const newSuggestionsMap = { ...prev };
      if (newSuggestionsMap[vendorIndex]) {
        Object.keys(newSuggestionsMap[vendorIndex]).forEach(categoryKey => {
          const categoryIndex = Number(categoryKey);
          const category = vendorsData[vendorIndex]?.categories[categoryIndex];

          if (category?.id === categoryId) {
            const updatedRows = {};
            Object.keys(newSuggestionsMap[vendorIndex][categoryIndex]).forEach(rowKey => {
              const rIndex = Number(rowKey);
              if (rIndex > rowIndex) {
                updatedRows[rIndex - 1] = newSuggestionsMap[vendorIndex][categoryIndex][rIndex];
              } else if (rIndex < rowIndex) {
                updatedRows[rIndex] = newSuggestionsMap[vendorIndex][categoryIndex][rIndex];
              }
            });
            newSuggestionsMap[vendorIndex][categoryIndex] = updatedRows;
          }
        });
      }
      return newSuggestionsMap;
    });
  };

  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };

  const handleJobCheckboxChange = (vendorIndex, categoryIndex, isChecked) => {
    setVendorsData(prevVendors =>
      prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        return {
          ...vendor,
          categories: vendor.categories.map((category, cIndex) => {
            if (cIndex !== categoryIndex) return category;

            return {
              ...category,
              isChecked,
              rows: category.rows.map(row => ({
                ...row,
                isChecked
              }))
            };
          })
        };
      })
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleVendorCheckboxChange = (vendorId, isChecked) => {
    setSelectedVendorIdArray(prev => {
      if (isChecked) {
        // Add if not already present
        if (!prev.includes(vendorId)) {
          return [...prev, vendorId];
        }
        return prev;
      } else {
        // Remove
        return prev.filter(id => id !== vendorId);
      }
    });
  };

  const vendorInvoiceMap = new Map();

  vendorsData.forEach((vendor, vendorIndex) => {

    vendor.categories?.forEach((category, categoryIndex) => {

      if (category.isChecked === false) return;

      category.rows?.forEach((row, rowIndex) => {

        if (row.isChecked === false) return;
        if (!row.vendor_inv_number) return;

        const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
        const vendorId = vendor.vendor_id || selectedVendorIds[attachmentKey];

        if (!vendorId) return;

        const key = `${vendorId}_${row.vendor_inv_number}`;

        vendorInvoiceMap.set(key, {
          vendorId,
          invoiceNo: row.vendor_inv_number
        });

      });

    });

  });

  const handleSubmit = async (actionType) => {
    if (isSaving || isSubmitting) return;

    if (!vendorDetails || vendorDetails.length === 0) {
      toast.error("Vendor Invoice details are required for all vendors");
      return;
    }

    if (!selectedVendorIdArray || selectedVendorIdArray.length === 0) {
      toast.error("No vendors selected");
      return;
    }

    let errors = {};
    let firstErrorMessage = "";

    for (const [vendorIndex, vendor] of vendorsData.entries()) {
      if (!selectedVendorIdArray.includes(vendor.vendor_id)) continue;

      for (const [categoryIndex, category] of (vendor.categories || []).entries()) {
        if (category.isChecked === false) continue;

        for (const [rowIndex, row] of (category.rows || []).entries()) {
          if (row.isChecked === false) continue;

          const jobNo = category.jobNo;
          const chargeCode = row.chargecode || "N/A";

          const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
          const headerVendorId = vendor.vendor_id;
          const lineVendorId = selectedVendorIds[attachmentKey];

          if (!headerVendorId && !lineVendorId) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_id")] = "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor is required`;
            continue
          }

          if (!row.vendor_inv_number) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_inv_number")] = true && "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor Invoice Number is required`;
          }

          if (!row.vendor_inv_date) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_inv_date")] = true && "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor Invoice Date is required`;
          }
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(firstErrorMessage);
      return;
    }
    const invoiceDateMap = {};

    for (const vendor of vendorsData) {
      if (!selectedVendorIdArray.includes(vendor.vendor_id)) continue;

      for (const category of vendor.categories || []) {
        if (category.isChecked === false) continue;

        for (const row of category.rows || []) {
          if (row.isChecked === false) continue;

          const invNo = row.vendor_inv_number?.trim();
          const invDate = row.vendor_inv_date;

          if (!invNo || !invDate) continue;

          if (!invoiceDateMap[invNo]) {
            invoiceDateMap[invNo] = invDate;
          } else {
            if (invoiceDateMap[invNo] !== invDate) {
              toast.error(
                `Vendor Invoice Number "${invNo}" must have the same Vendor Invoice Date`
              );
              return;
            }
          }
        }
      }
    }

    if (actionType === "save") {
      setIsSaving(true);
    } else {
      setIsSubmitting(true);
    }

    try {
      const generateInvoiceValue = vendorsData.length > 0 ? "1" : "0";

      const vendors = vendorsData
        .filter(
          vendor =>
            vendor &&
            Array.isArray(vendor.categories) &&
            selectedVendorIdArray.includes(vendor.vendor_id)
        )
        .map((vendor, vendorIndex) => {
          const jobMap = new Map();

          const vendorInvoiceNumbers = new Set();

          vendor.categories.forEach(category => {
            if (category.isChecked === false) return;

            (category.rows || []).forEach(row => {
              if (row.isChecked === false) return;
              if (row.vendor_inv_number) {
                vendorInvoiceNumbers.add(row.vendor_inv_number);
              }
            });
          });

          const vendorInvoiceMeta =
            actionType === "submit" && Array.isArray(invoices)
              ? invoices.reduce((acc, inv) => {
                if (vendorInvoiceNumbers.has(inv.invoice_no)) {
                  acc[inv.invoice_no] = {
                    remarks: inv.remarks || "",
                    tax_code: inv.tax_code?.value || null,
                  };
                }
                return acc;
              }, {})
              : {};

          vendor.categories
            .filter(category => category.isChecked !== false)
            .forEach((category, categoryIndex) => {
              (category.rows || [])
                .filter(row => row.isChecked !== false)
                .forEach((row, rowIndex) => {
                  const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
                  const vendorId = vendor.vendor_id || selectedVendorIds[attachmentKey];
                  const hasNewFile = row.uploadedFiles?.length > 0;

                  const job_line_item = {
                    project_id: row.project_id || category.rows?.[0]?.project_id || 0,
                    job_type_id: row.jobTypeId,
                    job_line_id: row.jobLineId,
                    charge_id: selectedChargeIds[attachmentKey] || 0,
                    description_of_charges: row.description || "",
                    vendor_inv_number: row.vendor_inv_number || "",
                    vendor_inv_date: row.vendor_inv_date || null,
                    po_wo_number: row.po_wo_number || null,
                    po_wo_date: row.po_wo_date || null,
                    vendor_id: vendorId,
                    unit_of_quantity: parseFloat(row.costunitQuantity) || 0,
                    accrual: parseFloat(row.costAccrual) || 0,
                    remarks: row.costRemarks || "",
                    unit_of_rate: parseFloat(row.costRate) || 0,
                    net_total: parseFloat(row.costNetTotal) || 0,
                    contract_value: parseFloat(row.costContractValue) || 0,
                    attachment_key: {
                      cost: attachmentKey,
                    }
                  };


                  if (!hasNewFile && row.existingAttachmentUrl) {
                    job_line_item.existing_cost_attachment_url = row.existingAttachmentUrl;
                  }

                  const jobId = row.jobIds || 0;
                  if (!jobMap.has(jobId)) {
                    jobMap.set(jobId, {
                      id: jobId,
                      jobnumber: category.jobNo || "",
                      project_id: row.project_id,
                      job_type_id: row.jobTypeId || 0,
                      job_created_date: new Date().toISOString().split("T")[0],
                      ff_plant_id: ffPlantCode,
                      job_line: [],
                    });
                  }

                  jobMap.get(jobId).job_line.push(job_line_item);
                });
            });

          const vendorJobs = Array.from(jobMap.values()).filter(
            job => job.job_line.length > 0
          );

          if (vendorJobs.length === 0) return null;

          const divisionType =
            vendorsData?.[0]?.categories?.[0]?.rows?.[0]?.division_type?.toLowerCase() || null;

          const existingVendorAttachmentMap = {};

          if (Array.isArray(invoices)) {
            invoices.forEach((inv) => {
              if (!inv.existing_vendor_attachment?.length) return;

              if (vendorInvoiceNumbers.has(inv.invoice_no)) {
                existingVendorAttachmentMap[inv.invoice_no] =
                  inv.existing_vendor_attachment;
              }
            });
          }

          return {
            jobs: vendorJobs,
            actions: [actionType],
            invoice_target: "cost",
            invoice_mode: invoiceMode,
            generate_invoice: generateInvoiceValue,
            division_type: divisionType,
            vendor_ids: Array.from(
              new Set(
                vendor.categories.flatMap((category, categoryIndex) =>
                  (category.rows || [])
                    .filter(row => row.isChecked !== false)
                    .map((row, rowIndex) => {
                      const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
                      return vendor.vendor_id || selectedVendorIds[attachmentKey];
                    })
                )
              )
            ).filter(Boolean),
            invoice_meta: vendorInvoiceMeta,
            existing_vendor_attachment_url:
              Object.keys(existingVendorAttachmentMap).length > 0
                ? existingVendorAttachmentMap
                : undefined
          };
        })
        .filter(vendor => vendor !== null && vendor.jobs && vendor.jobs.length > 0);

      const payload = {
        vendors,
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(payload));

      vendorsData.forEach((vendor, vendorIndex) => {
        vendor.categories
          ?.filter(category => category.isChecked !== false)
          .forEach((category, categoryIndex) => {
            category.rows
              ?.filter(row => row.isChecked !== false)
              .forEach((row, rowIndex) => {
                const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
                if (row.uploadedFiles?.length > 0) {
                  row.uploadedFiles.forEach(file => {
                    formData.append(`attachments[${attachmentKey}][]`, file);
                  });
                }
              });
          });
      });

      if (invoices && Array.isArray(invoices)) {
        invoices.forEach((inv) => {
          if (!inv.vendor_attachment?.file) return;
          const key = `${inv.vendor_id}_${inv.invoice_no}`;
          if (vendorInvoiceMap.has(key)) {
            formData.append(`vendor_attachment[${key}]`, inv.vendor_attachment.file);
          }
        });
      }

      console.log("Submitting payload:", JSON.stringify(payload, null, 2));

      const response = await axiosInstance.post(
        "/invoice/cost_invoice_save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200 && response.data.success === true) {
        toast.success(
          actionType === "submit"
            ? "Cost Invoice(s) submitted successfully!"
            : "Cost Invoice(s) saved successfully!"
        );
        navigate("/costInvoice");
      } else if (response.data.success === false) {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error submitting invoice:", error);

      const responseData = error?.response?.data;

      if (responseData?.errors && typeof responseData.errors === 'object') {
        Object.entries(responseData.errors).forEach(([vendorKey, messages]) => {
          messages.forEach(msg => {
            toast.error(`${vendorKey}: ${msg}`);
          });
        });
      } else {
        const backendMessage = responseData?.message || error.message || "Unknown error occurred";
        toast.error("Error while submitting: " + backendMessage);
      }
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };

  const handleRemoveAttachment = (vendorIndex, categoryId, rowIndex) => {
    setVendorsData(prevVendors =>
      prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        return {
          ...vendor,
          categories: vendor.categories.map(category => {
            if (category.id !== categoryId) return category;

            return {
              ...category,
              rows: category.rows.map((row, rIndex) => {
                if (rIndex !== rowIndex) return row;

                return {
                  ...row,
                  attachment: "",
                  existingAttachmentUrl: "",
                  uploadedFiles: []
                };
              })
            };
          })
        };
      })
    );
  };

  const fetchSuggestions = async (searchTerm = "", rowIndex, index, vendorIndex) => {
    try {
      setSuggestionsMap([]);
      const response = await axiosInstance.get(
        `/getnonprojectcostchargecodes`,
        {
          params: {
            term: searchTerm,
            cost_invoice_type: invoiceMode
          }
        }
      );

      if (response.data?.chargecodes) {

        const newSuggestions = response.data?.chargecodes || [];
        setSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[vendorIndex]) updated[vendorIndex] = {};
          if (!updated[vendorIndex][index]) updated[vendorIndex][index] = {};
          updated[vendorIndex][index][rowIndex] = newSuggestions;
          return updated;
        });

        setShowSuggestionsMap(prev => ({
          ...prev,
          [`${vendorIndex}_${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);

      setSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[vendorIndex]) updated[vendorIndex] = {};
        if (!updated[vendorIndex][index]) updated[vendorIndex][index] = {};
        updated[vendorIndex][index][rowIndex] = [];
        return updated;
      });

      setShowSuggestionsMap(prev => ({
        ...prev,
        [`${vendorIndex}_${index}_${rowIndex}`]: false,
      }));
    }
  };

  const handleJobCreated = (jobData) => {
    // Debugging: Log the incoming data
    console.log('Received jobData:', jobData);

    // Validate incoming data
    if (!jobData) {
      console.error('No job data received');
      return;
    }

    // Create a new category for the job with proper fallbacks
    const newCategory = {
      id: jobData.jobid,
      name: `Job-${jobData.jobNo}`,     // Fallback if jobNo is missing
      jobNo: jobData.jobNo || '',                // Ensure jobNo exists
      rows: (jobData.rows || []).map(row => {
        // Debug each row's chargecode
        console.log('Processing row with chargecode:', row.chargecode);

        return {
          jobTypeId: jobData.job_type_id,
          chargecode: row.chargecode,
          description: row.description || "",
          unitQuantity: row.unitQuantity || "",
          unitRatePrice: row.unitRatePrice || "",
          netTotal: row.netTotal || "",
          accrualSplit: row.netTotal || "",
          attachment: row.attachment || "",
          uploadedFiles: [],
          isChecked: false
        };
      })
    };

    // Add to allCategories
    setAllCategories(prev => [...prev, newCategory]);

    // Calculate summary only if we have valid data
    if (jobData.jobNo && jobData.rows) {
      setSummary(prev => [...prev, {
        job_no: jobData.jobNo,
        quantity: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.unitQuantity) || 0), 0),
        rate: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.unitRatePrice) || 0), 0),
        net_value: jobData.rows.reduce((sum, row) => sum + (parseFloat(row.netTotal) || 0), 0)
      }]);
    } else {
      console.error('Missing required data for summary:', {
        hasJobNo: !!jobData.jobNo,
        hasRows: !!jobData.rows
      });
    }
  };

  const handleSelectAllJobsForVendor = (vendorIndex, isChecked) => {
    setVendorsData(prevVendors =>
      prevVendors.map((vendor, vIndex) => {
        if (vIndex !== vendorIndex) return vendor;

        const updatedCategories = vendor.categories.map(category => ({
          ...category,
          isChecked,
          rows: category.rows.map(row => ({
            ...row,
            isChecked
          }))
        }));

        return {
          ...vendor,
          categories: updatedCategories
        };
      })
    );
  };


  const loadJobs = async (inputValue) => {
    try {
      const response = await axiosInstance.post('/job/add_cost_job', {
        project_id: Number(projectId),
        existing_job_id: selectedJobId || [],
        search: inputValue,
      });

      if (response.data.success && Array.isArray(response.data.jobnumber)) {
        return response.data.jobnumber.map(job => ({
          value: String(job.value),
          label: String(job.label),
        }));
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error loading jobs:", error);
      return [];
    }
  };


  useEffect(() => {
    console.log("updated selectedJobIddddddddddddddddddddddd", selectedJobId);
  }, [selectedJobId]);



  const handleAddJobsAndRegenerate = async (newJobIds) => {
    // Merge existing and new IDs
    const allJobIds = Array.from(new Set([...selectedJobId, ...newJobIds]));

    if (allJobIds.length === 0) {
      toast.warning("Please select at least one job to generate the bill");
      return;
    }

    try {
      // Use only cost endpoint here
      const endpoint = "/job/generate_cost_invoice";

      const response = await axiosInstance.post(endpoint, {
        job_ids: allJobIds
      });

      if (response.data.success) {
        toast.success("Cost bill regenerated successfully!");

        // Now navigate to *this* page again with new billData and job IDs
        navigate("/costBillPage", {
          state: {
            billData: response.data,
            selectedBills: allJobIds,
            billType: "cost"
          }
        });

        setShowAddPopup(false);  // Close the popup
      } else {
        toast.error(response.data.message || "Failed to regenerate cost bill");
      }
    } catch (error) {
      console.error("Error generating cost bill:", error);
      toast.error(error.response?.data?.message || "Failed to regenerate cost bill");
    }
  };



  const handleRemoveJob = async (jobIdToRemove) => {
    const confirmed = window.confirm("Are you sure you want to remove this job?");
    if (!confirmed) return;

    const updatedJobs = selectedJobId.filter(
      (jobId) => Number(jobId) !== Number(jobIdToRemove)
    );

    if (updatedJobs.length === 0) {
      toast.warning("At least one job is required to generate the bill");
      return;
    }

    setSelectedJobs(updatedJobs);

    try {
      const endpoint = "/job/generate_cost_invoice"; // Cost endpoint
      const response = await axiosInstance.post(endpoint, {
        job_ids: updatedJobs
      });

      if (response.data.success) {
        toast.success("Cost bill regenerated successfully!");

        navigate("/costBillPage", {
          state: {
            billData: response.data,
            selectedBills: updatedJobs,
            billType: "cost"
          }
        });
      } else {
        toast.error(response.data.message || "Failed to regenerate cost bill");
      }
    } catch (error) {
      console.error("Error regenerating cost bill:", error);
      toast.error(error.response?.data?.message || "Failed to regenerate cost bill");
    }
  };

  const fetchVendorSuggestions = async (searchTerm = "") => {
    try {
      const response = await axiosInstance.get(
        "/vendor/autosuggestion",
        { params: { term: searchTerm } }
      );
      return response.data?.autosuggestion || [];
    } catch (error) {
      console.error("Failed to fetch vendor suggestions:", error);
      return [];
    }
  };

  const fileInputRef = useRef();

  const handleRemoveVendorAttachment = () => {
    setVendorAttachment(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  useEffect(() => {
    if (vendorsData.length > 0) {
      setVendorDetails((prevDetails) => {
        const newDetails = vendorsData.map(vendor => {
          const existing = prevDetails.find(v => v.vendor_id === vendor.vendor_id);
          return existing || {
            vendor_id: vendor.vendor_id,
            invNumber: '',
            invDate: '',
            attachment: null
          };
        });
        return newDetails;
      });
    }
  }, [vendorsData]);

  const loadVendorOptions = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get("/vendor/autosuggestion", {
        params: { term: inputValue || '' }
      });

      const data = res.data;

      if (data.success && Array.isArray(data.autosuggestion)) {
        const mapped = data.autosuggestion.map((item) => ({
          label: item.label,
          value: item.value,
        }));

        callback(mapped);
      } else {
        callback([]);
      }
    } catch (error) {
      console.error("Vendor suggestion error:", error);
      callback([]);
    }
  };

  const loadTaxCodes = async (inputValue) => {
    try {
      const response = await axiosInstance.get("/projects/get_tax_code", {
        params: { term: inputValue || '' },
      });

      return response.data?.autosuggestion || [];
    } catch (error) {
      console.error("Tax code load error:", error);
      return [];
    }
  };

  const handlePreviewSubmit = async () => {
    if (isLoading) return;

    if (!selectedVendorIdArray || selectedVendorIdArray.length === 0) {
      toast.error("No vendors selected");
      return;
    }

    let errors = {};
    let firstErrorMessage = "";

    for (const [vendorIndex, vendor] of vendorsData.entries()) {
      if (!selectedVendorIdArray.includes(vendor.vendor_id)) continue;

      for (const [categoryIndex, category] of (vendor.categories || []).entries()) {
        if (category.isChecked === false) continue;

        for (const [rowIndex, row] of (category.rows || []).entries()) {
          if (row.isChecked === false) continue;

          const jobNo = category.jobNo;
          const chargeCode = row.chargecode || "N/A";

           const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
          const headerVendorId = vendor.vendor_id;
          const lineVendorId = selectedVendorIds[attachmentKey];

          if (!headerVendorId && !lineVendorId) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_id")] = "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor is required`;
            continue
          }

          if (!row.vendor_inv_number) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_inv_number")] = true && "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor Invoice Number is required`;
          }
          if (!row.vendor_inv_date) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_inv_date")] = true && "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor Invoice Date is required`;
          }

        }
      }
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(firstErrorMessage);
      return;
    }

    const invoiceDateMap = {};

    for (const vendor of vendorsData) {
      if (!selectedVendorIdArray.includes(vendor.vendor_id)) continue;

      for (const category of vendor.categories || []) {
        if (category.isChecked === false) continue;

        for (const row of category.rows || []) {
          if (row.isChecked === false) continue;

          const invNo = row.vendor_inv_number?.trim();
          const invDate = row.vendor_inv_date;

          if (!invNo || !invDate) continue;

          const key = `${vendor.vendor_id}_${invNo}`;

          if (!invoiceDateMap[key]) {
            invoiceDateMap[key] = invDate;
          } else if (invoiceDateMap[key] !== invDate) {
            toast.error(
              `Vendor Invoice Number "${invNo}" must have the same Vendor Invoice Date`
            );
            return;
          }
        }
      }
    }

    try {
      setIsLoading(true);

      const payload = buildPayloadForPreview("submit");

      const res = await axiosInstance.post(
        "/invoice/final_nonpo_structure",
        { data: payload }
      );

      if (res.data?.success) {
        const formatted = transformPopupData(res.data.data);
        setInvoices(formatted);
        setPopupAction("submit");
        setIsModalOpen(true);
      } else {
        toast.error("Failed to generate invoice preview");
      }

    } catch (err) {
      console.error(err);
      toast.error("Invoice preview failed");
    } finally {
      setIsLoading(false);
    }
  };

  const buildPayloadForPreview = (actionType) => {
    const generateInvoiceValue = vendorsData.length > 0 ? "1" : "0";

    const vendors = vendorsData
      .filter(v => v && Array.isArray(v.categories) && selectedVendorIdArray.includes(v.vendor_id))
      .map((vendor, vendorIndex) => {
        const jobMap = new Map();

        vendor.categories
          .filter(category => category.isChecked !== false)
          .forEach((category, categoryIndex) => {
            (category.rows || [])
              .filter(row => row.isChecked !== false)
              .forEach((row, rowIndex) => {

                const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
                const vendorId = vendor.vendor_id || selectedVendorIds[attachmentKey];
                const hasNewFile = row.uploadedFiles?.length > 0;

                // Create job_line item
                const job_line_item = {
                  project_id: row.project_id,
                  job_type_id: row.jobTypeId,
                  job_line_id: row.jobLineId,
                  charge_id: selectedChargeIds[attachmentKey] || 0,
                  description_of_charges: row.description || "",
                  vendor_inv_number: row.vendor_inv_number || "",
                  vendor_inv_date: row.vendor_inv_date || null,
                  po_wo_number: row.po_wo_number || null,
                  po_wo_date: row.po_wo_date || null,
                  vendor_id: vendorId,
                  unit_of_quantity: parseFloat(row.costunitQuantity) || 0,
                  accrual: parseFloat(row.costAccrual) || 0,
                  remarks: row.costRemarks || "",
                  unit_of_rate: parseFloat(row.costRate) || 0,
                  net_total: parseFloat(row.costNetTotal) || 0,
                  contract_value: parseFloat(row.costContractValue) || 0,
                  // vendor_attachment_key: attachmentKey,
                  // attachment_key: {
                  //   cost: attachmentKey,
                  // },
                  // ...(hasNewFile
                  //   ? {}
                  //   : row.existingAttachmentUrl && {
                  //     existing_cost_attachment_url: row.existingAttachmentUrl,
                  //   }),
                };

                const jobId = row.jobIds || 0;

                if (!jobMap.has(jobId)) {
                  jobMap.set(jobId, {
                    id: jobId,
                    jobnumber: category.jobNo || "",
                    project_id: row.project_id,
                    job_type_id: row.jobTypeId || 0,
                    job_created_date: new Date().toISOString().split("T")[0],
                    job_line: [],
                  });
                }

                jobMap.get(jobId).job_line.push(job_line_item);
              });
          });

        const vendorJobs = Array.from(jobMap.values()).filter(j => j.job_line.length);

        if (!vendorJobs.length) return null;

        const divisionType =
          vendorsData?.[0]?.categories?.[0]?.rows?.[0]?.division_type?.toLowerCase() || null;

        return {
          jobs: vendorJobs,
          vendor_ids: Array.from(
            new Set(
              vendor.categories.flatMap((category, categoryIndex) =>
                (category.rows || [])
                  .filter(row => row.isChecked !== false)
                  .map((row, rowIndex) => {
                    const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
                    return vendor.vendor_id || selectedVendorIds[attachmentKey];
                  })
              )
            )
          ).filter(Boolean),
          invoice_target: "cost",
          invoice_mode: invoiceMode,
          generate_invoice: generateInvoiceValue,
          actions: [actionType],
          division_type: divisionType,
        };
      })
      .filter(Boolean);

    return { vendors };
  };

  const transformPopupData = (data) => {
    const result = [];

    Object.values(data).forEach(vendor => {
      const matchedVendor = vendorsData.find(v => v.vendor_id === vendor.vendor_id);
      const existingAttachments = matchedVendor?.existing_vendor_attachment || [];
      Object.values(vendor.vendor_invoice_number).forEach(inv => {
        result.push({
          vendor_id: vendor.vendor_id,
          invoice_no: inv.vendor_invoice_number,
          remarks: "",
          tax_code: null,
          rows: inv.charges,
          vendor_attachment: null,
          existing_vendor_attachment: existingAttachments || []
        });
      });
    });

    return result;
  };

  const updateInvoice = (index, field, value) => {
    setInvoices(prev =>
      prev.map((inv, i) => {
        if (i !== index) return inv;

        const updatedInv = { ...inv, [field]: value };

        if (field === "vendor_attachment" && value) {
          updatedInv.vendor_attachment_data = {
            vendor_id: value.vendor_id || inv.vendor_id || null,
            invoice_no: value.invoice_no || inv.invoice_no,
            file: value.file
          };
        }

        return updatedInv;
      })
    );
    if (field === 'remarks') {
      setInvoiceRemarks(prev => ({
        ...prev,
        [index]: value
      }));
    }
  };

  const handlePreviewSave = async () => {
    if (isLoading) return;

    if (!selectedVendorIdArray?.length) {
      toast.error("No vendors selected");
      return;
    }


    let errors = {};
    let firstErrorMessage = "";

    for (const [vendorIndex, vendor] of vendorsData.entries()) {
      if (!selectedVendorIdArray.includes(vendor.vendor_id)) continue;

      for (const [categoryIndex, category] of (vendor.categories || []).entries()) {
        if (category.isChecked === false) continue;

        for (const [rowIndex, row] of (category.rows || []).entries()) {
          if (row.isChecked === false) continue;

          const jobNo = category.jobNo;
          const chargeCode = row.chargecode || "N/A";

           const attachmentKey = `${vendorIndex}_${categoryIndex}_${rowIndex}`;
          const headerVendorId = vendor.vendor_id;
          const lineVendorId = selectedVendorIds[attachmentKey];

          if (!headerVendorId && !lineVendorId) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_id")] = "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor is required`;
            continue
          }

          if (!row.vendor_inv_number) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_inv_number")] = true && "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor Invoice Number is required`;
          }

          if (!row.vendor_inv_date) {
            errors[getErrorKey(vendorIndex, categoryIndex, rowIndex, "vendor_inv_date")] = true && "required";
            firstErrorMessage ||= `Job ${jobNo} | Charge ${chargeCode} → Vendor Invoice Date is required`;
          }
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(firstErrorMessage);
      return;
    }

    const invoiceDateMap = {};

    for (const vendor of vendorsData) {
      if (!selectedVendorIdArray.includes(vendor.vendor_id)) continue;

      for (const category of vendor.categories || []) {
        if (category.isChecked === false) continue;

        for (const row of category.rows || []) {
          if (row.isChecked === false) continue;

          const invNo = row.vendor_inv_number?.trim();
          const invDate = row.vendor_inv_date;

          if (!invNo || !invDate) continue;

          const key = `${vendor.vendor_id}_${invNo}`;

          if (!invoiceDateMap[key]) {
            invoiceDateMap[key] = invDate;
          } else if (invoiceDateMap[key] !== invDate) {
            toast.error(
              `Vendor Invoice Number "${invNo}" must have the same Vendor Invoice Date`
            );
            return;
          }
        }
      }
    }

    try {
      setIsLoading(true);

      const payload = buildPayloadForPreview("save");

      const res = await axiosInstance.post(
        "/invoice/final_nonpo_structure",
        { data: payload }
      );

      if (res.data?.success) {
        const formatted = transformPopupData(res.data.data);
        setInvoices(formatted);
        setPopupAction("save");
        setIsModalOpen(true);
      } else {
        toast.error("Preview failed");
      }

    } catch (err) {
      toast.error("Preview failed");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const initialJobInvoice = {};

    vendorsData.forEach((vendor, vIndex) => {
      vendor.categories.forEach((category, cIndex) => {
        const firstRowWithInvoice = category.rows.find(
          row => row.vendor_inv_number || row.vendor_inv_date
        );

        if (firstRowWithInvoice) {
          initialJobInvoice[`${vIndex}_${cIndex}`] = {
            vendor_inv_number: firstRowWithInvoice.vendor_inv_number,
            vendor_inv_date: firstRowWithInvoice.vendor_inv_date
          };
        }
      });
    });

    if (Object.keys(initialJobInvoice).length > 0 && Object.keys(jobLevelInvoice).length === 0) {
      setJobLevelInvoice(initialJobInvoice);
    }
  }, [vendorsData]);

  useEffect(() => {
    if (Object.keys(jobLevelInvoice).length === 0) return;

    vendorsData.forEach((vendor, vIndex) => {
      vendor.categories.forEach((category, cIndex) => {
        const key = `${vIndex}_${cIndex}`;
        const currentGlobal = jobLevelInvoice[key];
        if (!currentGlobal) return;

        const nonEmptyNumbers = category.rows
          .map(row => row.vendor_inv_number)
          .filter(num => num && num.trim() !== '');

        const nonEmptyDates = category.rows
          .map(row => row.vendor_inv_date)
          .filter(date => date && date.trim() !== '');

        const allSameNumber = nonEmptyNumbers.length === 0 ||
          nonEmptyNumbers.every(num => num === nonEmptyNumbers[0]);

        const allSameDate = nonEmptyDates.length === 0 ||
          nonEmptyDates.every(date => date === nonEmptyDates[0]);

        if (allSameNumber && nonEmptyNumbers.length > 0) {
          if (currentGlobal.vendor_inv_number !== nonEmptyNumbers[0]) {
            setJobLevelInvoice(prev => ({
              ...prev,
              [key]: {
                ...prev[key],
                vendor_inv_number: nonEmptyNumbers[0]
              }
            }));
          }
        }

        if (allSameDate && nonEmptyDates.length > 0) {
          if (currentGlobal.vendor_inv_date !== nonEmptyDates[0]) {
            setJobLevelInvoice(prev => ({
              ...prev,
              [key]: {
                ...prev[key],
                vendor_inv_date: nonEmptyDates[0]
              }
            }));
          }
        }
      });
    });
  }, [vendorsData]);

  const openCostRemarkPopup = (vendorIndex, rowIndex, lineIndex, value) => {
    setRemarkMeta({ vendorIndex, rowIndex, lineIndex, type: "cost" });
    setRemarkValue(value || "");
    setShowRemarkPopup(true);
  };

  const handleSaveRemark = (updatedValue) => {
    if (!remarkMeta) return;

    const { vendorIndex, rowIndex, lineIndex, type } = remarkMeta;

    if (type === "cost") {
      handleInputChange(
        { target: { value: updatedValue } },
        vendorIndex,
        rowIndex,
        lineIndex,
        "costRemarks"
      );
    } else {
      handleInputChange(
        { target: { value: updatedValue } },
        rowIndex,
        lineIndex,
        "salesRemarks"
      );
    }

    setShowRemarkPopup(false);
  };

  return (
    <>
      <GenerateInvoiceHeader onSearch={null} disableSearch={true} />
      <div className="invoice_popup">
        <div className="invoice_popup_header">
          <div className="invoice_popup_header_left">
            <img src={back_arrow} alt="Back Arrow" onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }} />
            <p className="new_cost_line">Cost Invoice</p>
          </div>
          <div className="invoice_popup_header_right">
            <button className="cancel_btn" onClick={() => navigate(-1)}>Cancel</button>
            <button
              className="cancel_btn"
              onClick={handlePreviewSave}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
            <button
              className="submit_btn"
              onClick={handlePreviewSubmit}
              disabled={isLoading}
            >
              Submit
            </button>
          </div>
        </div>

        {vendorsData.map((vendor, vendorIndex) => (
          <div key={vendor.vendor_id} className="vendor-section">
            <div className="invoice_popup_project">
              <div className="invoice-popup-project-content">
                <p className="invoice-popup-project-project">Vendor Name</p>

                <div className="invoice-popup-project-project-name ">
                  <input
                    type="checkbox"
                    checked={selectedVendorIdArray.includes(vendor.vendor_id)}
                    onChange={(e) => handleVendorCheckboxChange(vendor.vendor_id, e.target.checked)}
                  />

                  {vendor.vendor_name && vendor.vendor_name.trim() !== '-' ? (
                    <span style={{ fontSize: '13px', fontWeight: '500' }}>{vendor.vendor_name}</span>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                      <AsyncSelect
                        cacheOptions
                        defaultOptions
                        loadOptions={loadVendorOptions}
                        onChange={(selectedOption) => {
                          setVendorInputValues((prev) => ({
                            ...prev,
                            [`${vendorIndex}_vendor`]: selectedOption?.label || "",
                          }));
                          setSelectedVendorIds((prev) => ({
                            ...prev,
                            [`${vendorIndex}_vendor`]: selectedOption?.value || null,
                          }));
                        }}
                        value={
                          vendorInputValues[`${vendorIndex}_vendor`]
                            ? {
                              label: vendorInputValues[`${vendorIndex}_vendor`],
                              value: selectedVendorIds[`${vendorIndex}_vendor`] || ""
                            }
                            : null
                        }
                        placeholder="Select vendor"
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: '250px',
                            fontSize: '12px',
                            fontWeight: '500',
                          }),
                          control: (base) => ({
                            ...base,
                            minHeight: '27px',
                            height: '27px',
                            borderRadius: '6px',
                            fontSize: '12px',
                            padding: '0px 2px',
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            paddingTop: 0,
                            paddingBottom: 0,
                            paddingLeft: 6,
                            paddingRight: 6,
                            height: '27px',
                          }),
                          input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: '27px',
                          }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: '2px',
                          }),
                          menu: (base) => ({
                            ...base,
                            fontSize: '12px',
                          }),

                        }}
                      />

                      <button
                        onClick={async () => {
                          const vendorName = vendorInputValues[`${vendorIndex}_vendor`];
                          const vendorId = selectedVendorIds[`${vendorIndex}_vendor`];

                          if (!vendorName?.trim() || !vendorId) {
                            toast.warning("Please select a valid vendor");
                            return;
                          }

                          try {
                            const emptyVendorLineItems = [];
                            const currentVendorData = vendorsData[vendorIndex];

                            if (currentVendorData?.categories) {
                              currentVendorData.categories.forEach((category) => {
                                if (category?.rows) {
                                  category.rows.forEach((row) => {
                                    const currentVendor = vendorInputValues[`${vendorIndex}_${category.id}_${row.id}`] ||
                                      row.vendor_name;

                                    if ((!currentVendor || currentVendor.trim() === '-' || currentVendor.trim() === '') &&
                                      row.jobLineId) {
                                      emptyVendorLineItems.push(row.jobLineId);
                                    }
                                  });
                                }
                              });
                            }

                            if (emptyVendorLineItems.length === 0) {
                              toast.warning("No line items without vendor found");
                              return;
                            }

                            const response = await axiosInstance.post(
                              '/job/bulkjobline_vendor_update',
                              {
                                job_cost_line_ids: emptyVendorLineItems,
                                vendor_id: vendorId
                              }
                            );

                            if (response.data?.success) {
                              toast.success(`Updated vendor for ${emptyVendorLineItems.length} line item(s)`);

                              try {
                                const refreshResponse = await axiosInstance.post(
                                  '/job/generate_multi_cost_line_invoice',
                                  { jobs: selectedJobId, cost_invoice_type: invoiceMode }
                                );

                                if (refreshResponse.data?.success && refreshResponse.data?.vendors) {
                                  navigate("/costBillPage", {
                                    state: {
                                      billData: refreshResponse.data,
                                      selectedBills: selectedJobId,
                                    }
                                  })
                                }
                              } catch (refreshError) {
                                console.error("Refresh error:", refreshError);
                                toast.error("Updated vendor but failed to refresh data");
                              }
                            } else {
                              toast.error(response.data?.message || "Failed to update vendor");
                            }
                          } catch (error) {
                            console.error("Update error:", error);
                            toast.error(error.response?.data?.message || "Failed to update vendor");
                          }
                        }}
                        style={{
                          padding: '6px 12px',
                          background: '#097BED',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '6px',
                          fontSize: '12px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          height: '27px'
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="invoice-popup-project-summary">
                <p className="invoice-popup-summary-summary">Summary</p>
                <table className="invoice-popup-summary-table">
                  <thead>
                    <tr>
                      <th>Project</th>
                      <th>Jobs</th>
                      <th>Quantity</th>
                      <th>Rate</th>
                      <th>Net Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendor.summary.map((job, index) => (
                      <tr key={index}>
                        <td>{job.project_name}</td>
                        <td>{job.job_no}</td>
                        <td>{job.cost_unit_of_quantity}</td>
                        <td>{job.cost_unit_of_rate}</td>
                        <td>{job.cost_net_total}</td>
                      </tr>
                    ))}
                    <tr className="total-row">
                      <td colSpan="2">Total</td>
                      <td>
                        {vendor.summary.reduce((sum, job) => sum + parseFloat(job.cost_unit_of_quantity || 0), 0).toFixed(2)}
                      </td>
                      <td>
                        {vendor.summary.reduce((sum, job) => sum + parseFloat(job.cost_unit_of_rate || 0), 0).toFixed(2)}
                      </td>
                      <td>
                        {vendor.summary.reduce((sum, job) => sum + parseFloat(job.cost_net_total || 0), 0).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="invoice_popup_categories">
              <div
                className="invoice-generate-job"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 10px",
                  gap: "10px",
                }}
              >
                <div className="sales-select-all-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelectAllJobsForVendor(vendorIndex, e.target.checked)}
                    checked={
                      vendor.categories.every(category => category.isChecked !== false)
                    }
                  />
                  <label htmlFor="selectAll" style={{ fontSize: '13px', fontWeight: '600', fontFamily: 'Work Sans', cursor: 'pointer', margin: '0px' }}>Select All Jobs</label>
                </div>

                <div style={{ display: "flex", gap: "10px" }}>
                  <AdditionalPermissionWrapper permissionKey="add_cost_jobs" moduleId={ModuleId}>
                    <button className="invoice-generate-job-btn" onClick={async () => { setShowAddPopup(true); await loadJobs(); }}>
                      + Add Job
                    </button>
                  </AdditionalPermissionWrapper>
                  {/* <button className="invoice-generate-job-btn" onClick={() => setShowPopup(true)}>
                Create Job
              </button> */}
                </div>
              </div>


              {showaddPopup && (
                <div className="invoice-add-creation-popup-overlay">
                  <div className="invoice-add-creation-popup-container">
                    <div className="invoice-add-creation-popup-header">
                      <h2>Add Job</h2>
                      <button
                        className="invoice-add-creation-close-button"
                        onClick={() => setShowAddPopup(false)}
                      >
                        ×
                      </button>
                    </div>

                    <form>
                      <div className="invoice-add-creation-popup-body">
                        <div className="invoice-add-creation-form-group">
                          <label htmlFor="project" className="labels">Vendor Name</label>
                          <input
                            type="text"
                            id="project"
                            value={projectName}
                            readOnly
                            style={{ margin: "0px", backgroundColor: '#E9F4FF' }}
                          />
                        </div>

                        <div className="invoice-add-creation-form-group">
                          <label className="name">Job Number</label>
                          <AsyncSelect
                            isMulti
                            value={selectedJobOptions}
                            inputValue={jobInputValue}
                            onInputChange={(value) => setJobInputValue(value)}
                            onChange={(selectedOptions) => {
                              const selected = selectedOptions || [];
                              setSelectedJobOptions(selected);
                              const jobIds = selected.map(opt => Number(opt.value));
                              setSelectedJobIds(jobIds);
                              setSelectedJobId(prev => Array.from(new Set([...prev, ...jobIds])));
                            }}

                            loadOptions={loadJobs}
                            placeholder="Search and select job(s)..."
                            cacheOptions
                            defaultOptions
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            menuPortalTarget={document.body}
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                width: '100%',
                                height: '37px',
                                borderRadius: '12px',
                                fontSize: '13px',
                                fontFamily: 'Work Sans',
                                borderColor: state.isFocused ? '#0747A6' : '#D0D6DF',
                                boxShadow: state.isFocused ? '0 0 0 1px #0747A6' : 'none',
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                maxHeight: '100%',
                                overflowY: 'auto',
                                overflowX: 'auto',
                                display: 'flex',
                                flexWrap: 'nowrap',
                              }),
                              container: (base) => ({
                                ...base,
                                width: '100%',
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: '13px',
                                fontFamily: 'Work Sans',
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: '#E6F0FF',
                                borderRadius: '4px',
                                padding: '2px 6px',
                                margin: '1px',
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: '#0747A6',
                                fontSize: '11px',
                                fontWeight: 500,
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: '#0747A6',
                                ':hover': {
                                  backgroundColor: '#0747A6',
                                  color: 'white',
                                },
                              }),
                            }}
                            components={{
                              DropdownIndicator: null,
                              IndicatorSeparator: null,
                              Option: ({ ...props }) => (
                                <components.Option {...props}>
                                  <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <input
                                      type="checkbox"
                                      checked={props.isSelected}
                                      readOnly
                                      style={{ marginRight: 8 }}
                                    />
                                    {props.label}
                                  </div>
                                </components.Option>
                              ),
                            }}
                          />
                        </div>

                      </div>
                      <div className="invoice-add-creation-popup-footer">
                        <button
                          type="button"
                          className="invoice-add-submit-button"
                          onClick={() => handleAddJobsAndRegenerate(selectedJobIds)}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {showPopup && (
                <CreateJobs
                  onClose={() => setShowPopup(false)}
                  onJobCreated={(jobData) => {
                    handleJobCreated(jobData);
                    setShowPopup(false);
                  }}
                  projectId={projectId}
                  projectName={projectName}
                  selectedJobId={selectedJobId}
                />
              )}

              {vendor.categories.map((category, index) => {
                // console.log("category data check", category),

                const isContract = category.contract_id !== null;
                const contractLabel = isContract ? "C" : "NC";
                console.log("contractLabellllllllll", contractLabel);
                const contractColor = isContract ? "#129990" : "#FFB22C";

                return (
                  <div key={category.id} className="invoice_popup_outercategory">
                    <div className="invoice_popup_category_header">
                      <div
                        className="category_name_left"
                        style={{
                          display: "flex",
                          alignItems: "center", // vertical center
                          justifyContent: "center", // horizontal center
                          gap: "8px", // spacing between text and image
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={category.isChecked !== false}
                          onChange={(e) => handleJobCheckboxChange(vendorIndex, index, e.target.checked)}
                        />
                        <span className="category_name">Job No - {category.id}</span>

                        <span
                          style={{
                            backgroundColor: contractColor,
                            color: "#fff",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            fontSize: "0.75rem",
                            fontWeight: "bold",
                          }}
                        >
                          {contractLabel}
                        </span>

                        <AdditionalPermissionWrapper permissionKey="remove_cost_jobs" moduleId={ModuleId}>
                          <img
                            src={delete_icon}
                            style={{ width: '25px', height: '25px', cursor: 'pointer' }}
                            alt="Delete"
                            onClick={() => handleRemoveJob(category.job_id)}
                          />
                        </AdditionalPermissionWrapper>

                        <div className="vendor-invoice-number-based-field">
                          <div className="vendor-field-group">
                            <label>Vendor Inv No</label>
                            <input type="text"
                              style={{ margin: '0px' }}
                              value={jobLevelInvoice[`${vendorIndex}_${index}`]?.vendor_inv_number || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setJobLevelInvoice(prev => ({
                                  ...prev,
                                  [`${vendorIndex}_${index}`]: {
                                    ...prev[`${vendorIndex}_${index}`],
                                    vendor_inv_number: value
                                  }
                                }));
                              }}
                              placeholder="Vendor Inv Number"
                            />
                          </div>

                          <div style={{
                            width: "1px",
                            backgroundColor: "#ccc",
                            alignSelf: "stretch"
                          }} />

                          <div className="vendor-field-group">
                            <label>Vendor Inv Date</label>
                            <input type="date"
                              value={jobLevelInvoice[`${vendorIndex}_${index}`]?.vendor_inv_date || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setJobLevelInvoice(prev => ({
                                  ...prev,
                                  [`${vendorIndex}_${index}`]: {
                                    ...prev[`${vendorIndex}_${index}`],
                                    vendor_inv_date: value
                                  }
                                }));
                              }}
                              placeholder="Select the Date"
                            />
                          </div>

                          <div className="apply-btn-wrapper">
                            <button
                              type="button"
                              className="btn apply-btn"
                              onClick={() => {
                                const globalData = jobLevelInvoice[`${vendorIndex}_${index}`] || {};

                                setVendorsData(prev =>
                                  prev.map((vendor, vIndex) =>
                                    vIndex !== vendorIndex ? vendor : {
                                      ...vendor,
                                      categories: vendor.categories.map((cat, cIndex) =>
                                        cIndex !== index ? cat : {
                                          ...cat,
                                          rows: cat.rows.map(row => ({
                                            ...row,
                                            vendor_inv_number:
                                              globalData.vendor_inv_number !== undefined
                                                ? globalData.vendor_inv_number
                                                : row.vendor_inv_number,

                                            vendor_inv_date:
                                              globalData.vendor_inv_date !== undefined
                                                ? globalData.vendor_inv_date
                                                : row.vendor_inv_date
                                          }))
                                        }
                                      )
                                    }
                                  )
                                );

                                setValidationErrors(prev => {
                                  const updated = { ...prev };

                                  category.rows.forEach((_, rIndex) => {
                                    delete updated[getErrorKey(vendorIndex, index, rIndex, "vendor_inv_number")];
                                    delete updated[getErrorKey(vendorIndex, index, rIndex, "vendor_inv_date")];
                                  });

                                  return updated;
                                });
                              }}
                            >
                              Apply
                            </button>
                          </div>
                        </div>

                      </div>
                      <div style={{
                        display: "flex",
                        gap: "10px",
                        fontSize: '11px',
                        flexWrap: "wrap"
                      }}>

                        {/* ACCURAL BOX */}
                        <div style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          width: 'auto',
                          height: '30px',
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                        }}>
                          <span style={{ color: "#C89C00", fontWeight: "600" }}>ACCRUAL :</span>
                          <span style={{ color: "#000" }}>₹ {category.costAccrual?.toLocaleString()}</span>
                        </div>

                        <div style={{
                          width: "1px",
                          backgroundColor: "#ccc",
                          alignSelf: "stretch"
                        }} />

                        {/* COST BOX */}
                        <div style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          width: 'auto',
                          height: '30px',
                          boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                        }}>
                          <span style={{ color: "#007bff", fontWeight: "600" }}>COST :</span>
                          <span style={{ color: "#000" }}>Net Total : ₹ {category.costNetTotal?.toLocaleString()}</span>
                          {(() => {
                            const costnetTotal = parseFloat(category.costNetTotal) || 0;
                            const costaccrual = parseFloat(category.costAccrual) || 0;
                            const difference = costnetTotal - costaccrual;
                            const isPositive = difference >= 0;

                            return (
                              <span style={{
                                fontWeight: 600,
                                color: isPositive ? "green" : "red"
                              }}>
                                ({isPositive ? "+" : ""}{difference.toFixed(2)})
                              </span>
                            );
                          })()}
                        </div>

                      </div>
                    </div>

                    <div className="invoice_popup_category_subheader">
                      <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                        <div className="table-container">
                          <table className="invoice_table">
                            <thead>
                              <tr>
                                <th rowSpan="2">
                                  <input
                                    type="checkbox"
                                    checked={category.isChecked !== false}
                                    onChange={(e) => handleJobCheckboxChange(vendorIndex, index, e.target.checked)}
                                  /> </th>
                                <th colSpan="15" style={{ padding: '10px', color: '#097BED', backgroundColor: '#E0EFFF' }}>COST</th>

                              </tr>
                              <tr>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>CHARGE CODE</th>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>DESCRIPTION</th>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>VENDOR</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>Vendor Inv NO <span style={{ color: 'red' }}>*</span></th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>Vendor Inv Date <span style={{ color: 'red' }}>*</span></th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO NO</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO Date</th>
                                <th style={{ padding: '10px', backgroundColor: '#E0EFFF', textAlign: 'center' }}>REMARKS</th>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>ACCRUAL SPLIT</th>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>CONTRACT VALUE</th>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>QUANTITY</th>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>RATE</th>
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>NET TOTAL</th>
                                {/* <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>VENDOR ATTACHMENT<span style={{ color: 'red' }}>*</span></th> */}
                                <th style={{ backgroundColor: '#E0EFFF', textAlign: 'center' }}>ATTACHMENT</th>
                              </tr>
                            </thead>
                            <tbody>
                              {category.rows.map((row, lineindex) => {
                                console.log("Row detailsssssssss", row);
                                console.log("contractId checkkkkkkkkkkkkk", category);

                                const rowContractId = row.contract_id !== undefined ? row.contract_id : category.contract_id;
                                const isNonContract = rowContractId == null;
                                const canEditChargeDetails = isNonContract;


                                // const canEditQuantityRate = canEditCharges;


                                console.log("row.contract_id:", row.contract_id);
                                console.log("rowContractId:", rowContractId);
                                console.log("canEditChargeDetails:", canEditChargeDetails);

                                return (
                                  <tr key={lineindex}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={row.isChecked !== false} // Defaults to true if undefined
                                        onChange={(e) => handleCheckboxChange(e, vendorIndex, category.id, lineindex)}
                                      />
                                    </td>
                                    <td style={{ position: "relative" }}>
                                      <input
                                        style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                        type="text"
                                        // value={inputValues[index]?.[lineindex] || ""}
                                        value={inputValues[`${vendorIndex}_${index}_${lineindex}`]?.split("-")[0]?.trim() || ""}
                                        onChange={(e) => {
                                          // console.log("canEditChargeDetailsssssssssss", canEditChargeDetails);
                                          // if (!canEditChargeDetails) return;
                                          const val = e.target.value;
                                          handleInputChange(e, vendorIndex, index, lineindex, "chargecode")
                                          setInputValues((prev) => ({
                                            ...prev,
                                            [`${vendorIndex}_${index}_${lineindex}`]: val,
                                          }));

                                          fetchSuggestions(val, lineindex, index, vendorIndex);
                                        }}
                                        onFocus={() => {
                                          // if (!canEditChargeDetails) return;
                                          const list = suggestionsMap[index]?.[lineindex] || [];
                                          if (list.length > 0) {
                                            const list = suggestionsMap[index]?.[lineindex] || [];
                                            if (list.length > 0) {
                                              setShowSuggestionsMap(prev => ({ ...prev, [`${vendorIndex}_${index}_${lineindex}`]: true }));
                                            }
                                          }
                                        }}
                                        onBlur={() => {
                                          setTimeout(() => {
                                            setShowSuggestionsMap(prev => ({ ...prev, [`${vendorIndex}_${index}_${lineindex}`]: false }));
                                          }, 200);
                                        }}
                                        className="invoice_narrow_input_chargecode"
                                        placeholder="Search"
                                      // disabled={!canEditChargeDetails}
                                      />

                                      {showSuggestionsMap[`${vendorIndex}_${index}_${lineindex}`] && suggestionsMap[vendorIndex]?.[index]?.[lineindex]?.length > 0 && (
                                        <ul
                                          style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            right: 0,
                                            backgroundColor: "white",
                                            border: "1px solid #ccc",
                                            zIndex: 9999,
                                            maxHeight: "150px",
                                            overflowY: "auto",
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none",
                                          }}
                                        >
                                          {suggestionsMap[vendorIndex][index][lineindex].map((item) => (
                                            <li
                                              key={item.value}
                                              onMouseDown={() => {
                                                const selected = item.label;
                                                const chargeId = item.value;
                                                const supporting_doc = item.value2; // new


                                                setInputValues((prev) => ({
                                                  ...prev,
                                                  [index]: {
                                                    ...prev[index],
                                                    [`${vendorIndex}_${index}_${lineindex}`]: selected,
                                                  },
                                                }));

                                                setSelectedChargeIds((prev) => ({
                                                  ...prev,
                                                  [`${vendorIndex}_${index}_${lineindex}`]: chargeId
                                                }));

                                                handleInputChange({ target: { value: selected } }, vendorIndex, index, lineindex, "chargecode");
                                                setShowSuggestionsMap(prev => ({ ...prev, [`${vendorIndex}_${index}_${lineindex}`]: false }));


                                                // ✨ NEW PART: split and set description separately ✨
                                                const splitParts = selected.split("-");
                                                const chargeCodeOnly = splitParts[0] || "";
                                                const descriptionOnly = splitParts.slice(1).join("-") || "";


                                                // Update charge code field value (CT002)
                                                setInputValues((prev) => ({
                                                  ...prev,
                                                  [`${vendorIndex}_${index}_${lineindex}`]: chargeCodeOnly,
                                                }));


                                                handleInputChange({ target: { value: chargeCodeOnly } }, vendorIndex, index, lineindex, "chargecode")

                                                // Update description field value (TestCharge)
                                                handleInputChange({ target: { value: descriptionOnly } }, vendorIndex, index, lineindex, "description")


                                                // 🔥 Update supporting doc flag in that row
                                                setAllCategories(prev =>
                                                  prev.map((cat, catIndex) =>
                                                    catIndex === index
                                                      ? {
                                                        ...cat,
                                                        rows: cat.rows.map((row, rIndex) =>
                                                          rIndex === lineindex
                                                            ? { ...row, supporting_document: !!supporting_doc }
                                                            : row
                                                        ),
                                                      }
                                                      : cat
                                                  )
                                                );

                                              }}
                                              style={{
                                                padding: "8px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              {item.label}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </td>

                                    {/* <td>
                                    <input
                                      type="text"
                                      value={row.remarks}
                                      onChange={(e) => handleInputChange(e, category.id, index, "remarks")}
                                      className="invoice_small_input"
                                    />
                                  </td>   */}

                                    <td>
                                      <input
                                        type="text"
                                        value={row.description}
                                        // onChange={(e) => handleInputChange(e, index, lineindex, "description")}
                                        onChange={(e) => {
                                          // if (!canEditChargeDetails) return;
                                          handleInputChange(e, vendorIndex, index, lineindex, "description")

                                        }}
                                        className="invoice_narrow_input_description"
                                        // disabled={!canEditChargeDetails}
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans', }}
                                      />
                                    </td>
                                    {/* <td>
                                  <input
                                    type="number"
                                    value={row.unitQuantity}
                                    // onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                    onChange={(e) => {
                                      // if (!canEditQuantityRate) return;
                                      handleInputChange(e, index, lineindex, "unitQuantity");
                                    }}
                                    className="invoice_small_input"
                                    style={{ fontFamily: 'Work Sans' }}
                                  // disabled={!canEditQuantityRate}
                                  />
                                </td> */}

                                    <td style={{ position: 'relative' }}>
                                      <input
                                        type="text"
                                        className="contracts_small_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                        value={vendorInputValues[`${vendorIndex}_${index}_${lineindex}`] || ""}
                                        onChange={async (e) => {
                                          const val = e.target.value;
                                          setVendorInputValues(prev => ({
                                            ...prev,
                                            [`${vendorIndex}_${index}_${lineindex}`]: val,
                                          }));

                                          if (val.length >= 1) {
                                            const suggestions = await fetchVendorSuggestions(val);
                                            setVendorSuggestions(suggestions);
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${vendorIndex}_${index}_${lineindex}`]: true,
                                            }));
                                          } else {
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${vendorIndex}_${index}_${lineindex}`]: false,
                                            }));
                                          }
                                        }}
                                        onFocus={async () => {
                                          const val = vendorInputValues[`${vendorIndex}_${index}_${lineindex}`] || "";
                                          if (val.length >= 1) {
                                            const suggestions = await fetchVendorSuggestions(val);
                                            setVendorSuggestions(suggestions);
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${vendorIndex}_${index}_${lineindex}`]: true,
                                            }));
                                          }
                                        }}
                                        onBlur={() => {
                                          setTimeout(() => {
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${vendorIndex}_${index}_${lineindex}`]: false,
                                            }));
                                          }, 200);
                                        }}
                                        placeholder="Search vendor"
                                      />

                                      {showVendorSuggestions[`${vendorIndex}_${index}_${lineindex}`] && vendorSuggestions.length > 0 && (
                                        <ul style={{
                                          position: "absolute",
                                          top: "100%",
                                          left: 0,
                                          right: 0,
                                          backgroundColor: "white",
                                          border: "1px solid #ccc",
                                          zIndex: 999,
                                          maxHeight: "150px",
                                          overflowY: "auto",
                                          margin: 0,
                                          padding: 0,
                                          listStyle: "none",
                                        }}>
                                          {vendorSuggestions.map((vendor) => (
                                            <li
                                              key={vendor.value}
                                              onMouseDown={() => {
                                                setVendorInputValues(prev => ({
                                                  ...prev,
                                                  [`${vendorIndex}_${index}_${lineindex}`]: vendor.label,
                                                }));
                                                setSelectedVendorIds(prev => ({
                                                  ...prev,
                                                  [`${vendorIndex}_${index}_${lineindex}`]: vendor.value,
                                                }));
                                                setShowVendorSuggestions(prev => ({
                                                  ...prev,
                                                  [`${vendorIndex}_${index}_${lineindex}`]: false,
                                                }));
                                              }}
                                              style={{
                                                padding: "8px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              {vendor.label}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        className={`invoice_narrow_input_quantity ${validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_number")]
                                          ? "input-box-error"
                                          : ""
                                          }`}
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                        value={row.vendor_inv_number || ""}
                                        onChange={(e) => {
                                          handleInputChange(
                                            e,
                                            vendorIndex,
                                            index,
                                            lineindex,
                                            "vendor_inv_number"
                                          )
                                          setValidationErrors(prev => {
                                            const copy = { ...prev };
                                            delete copy[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_number")];
                                            return copy;
                                          });
                                        }
                                        }
                                      />
                                      {validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_number")] && (
                                        <div className="error-text">
                                          {validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_number")]}
                                        </div>
                                      )}
                                    </td>

                                    {/* Vendor Invoice Date */}
                                    <td>
                                      <input
                                        type="date"
                                        className={`invoice_narrow_input_quantity ${validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_date")]
                                          ? "input-box-error"
                                          : ""
                                          }`}
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                        value={row.vendor_inv_date || ""}
                                        onChange={(e) => {
                                          handleInputChange(
                                            e,
                                            vendorIndex,
                                            index,
                                            lineindex,
                                            "vendor_inv_date"
                                          )
                                          setValidationErrors(prev => {
                                            const copy = { ...prev };
                                            delete copy[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_date")];
                                            return copy;
                                          });
                                        }}
                                      />
                                      {validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_date")] && (
                                        <div className="error-text">
                                          {validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_inv_date")]}
                                        </div>
                                      )}
                                    </td>

                                    <td>
                                      <input
                                        type="text"
                                        value={row.po_wo_number}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleInputChange(e, vendorIndex, index, lineindex, "po_wo_number");
                                          }
                                        }}
                                        className="invoice_narrow_input_quantity"
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="date"
                                        value={row.po_wo_date}
                                        onChange={(e) => {
                                          handleInputChange(e, vendorIndex, index, lineindex, "po_wo_date")
                                        }}
                                        className="invoice_narrow_input_quantity"
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                      />
                                    </td>

                                    <td>
                                      <div
                                        className="table-tooltip-container"
                                        style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <input
                                          type="text"
                                          value={row.costRemarks}
                                          onChange={(e) => {
                                            handleInputChange(e, vendorIndex, index, lineindex, "costRemarks");
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === ",") e.preventDefault();
                                          }}
                                          className="invoice_narrow_input_remarks"
                                          style={{ margin: "0px", fontSize: "13px", fontFamily: "Work Sans" }}
                                        />
                                        {row.costRemarks?.trim() && (
                                          <SquarePen
                                            size={16}
                                            onClick={() =>
                                              openCostRemarkPopup(vendorIndex, index, lineindex, row.costRemarks)
                                            }
                                          />
                                        )}
                                        <span className="add-contract-tooltip">
                                          {row.costRemarks}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.costAccrual || 0}
                                        readOnly
                                        className="invoice_narrow_input"
                                        style={{ fontFamily: 'Work Sans' }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.costContractValue}
                                        disabled
                                        // onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                        onChange={(e) => {
                                          // if (!canEditQuantityRate) return;
                                          handleInputChange(e, index, lineindex, "costContractValue");
                                        }}
                                        className="invoice_narrow_input"
                                        style={{ fontFamily: 'Work Sans' }}
                                      // disabled={!canEditQuantityRate}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.costunitQuantity}
                                        // onChange={(e) => handleInputChange(e, index, lineindex, "unitQuantity")}
                                        onChange={(e) => {
                                          // if (!canEditQuantityRate) return;
                                          handleInputChange(e, vendorIndex, index, lineindex, "costunitQuantity")
                                        }}
                                        className="invoice_narrow_input_quantity"
                                        style={{ fontFamily: 'Work Sans' }}
                                      // disabled={!canEditQuantityRate}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.costRate}
                                        onChange={(e) => {
                                          handleInputChange(e, vendorIndex, index, lineindex, "costRate")
                                        }}
                                        className="invoice_narrow_input"
                                        style={{ fontFamily: 'Work Sans' }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        value={row.costNetTotal || ""} // From response data
                                        readOnly
                                        className="invoice_narrow_input"
                                        style={{ fontFamily: 'Work Sans' }}
                                      />
                                    </td>

                                    {/* <td className="vendor-invoice-attachment-cell">
                                      {!row.vendor_attachment && !row.existingVendorAttachmentUrl ? (
                                        <label className={`file_upload ${validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_attachment")]
                                          ? "upload-error"
                                          : ""
                                          }`}>
                                          <input
                                            type="file"
                                            style={{ display: "none" }}
                                            onChange={(e) => {
                                              const files = validateAttachments(e.target.files);
                                              if (!files.length) return;
                                              const file = e.target.files[0];
                                              if (!file) return;
                                              const errorKey = getErrorKey(
                                                vendorIndex,
                                                index,
                                                lineindex,
                                                "vendor_attachment"
                                              );

                                              setVendorsData(prev =>
                                                prev.map((vendor, vIndex) =>
                                                  vIndex !== vendorIndex ? vendor : {
                                                    ...vendor,
                                                    categories: vendor.categories.map((cat, cIndex) =>
                                                      cIndex !== index ? cat : {
                                                        ...cat,
                                                        rows: cat.rows.map((r, rIndex) =>
                                                          rIndex !== lineindex ? r : {
                                                            ...r,
                                                            vendor_attachment: file
                                                          }
                                                        )
                                                      }
                                                    )
                                                  }
                                                )
                                              );
                                              setValidationErrors(prev => {
                                                if (!prev[errorKey]) return prev;
                                                const updated = { ...prev };
                                                delete updated[errorKey];
                                                return updated;
                                              });
                                            }}
                                          />
                                          <img src={upload_icon} alt="Upload" className="upload_icon" />
                                          <span className="upload_text">Upload</span>
                                        </label>
                                      ) : row.existingVendorAttachmentUrl ? (
                                        <div className="attachment_view_section">
                                          <a
                                            href={row.existingVendorAttachmentUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="view_link"
                                          >
                                            <i className="fa fa-eye" style={{ marginRight: "5px" }}></i>
                                            <span className="view_text">View</span>
                                          </a>
                                          <button
                                            className="remove_file_btn"
                                            onClick={() => {
                                              setVendorsData(prev =>
                                                prev.map((vendor, vIndex) =>
                                                  vIndex !== vendorIndex ? vendor : {
                                                    ...vendor,
                                                    categories: vendor.categories.map((cat, cIndex) =>
                                                      cIndex !== index ? cat : {
                                                        ...cat,
                                                        rows: cat.rows.map((r, rIndex) =>
                                                          rIndex !== lineindex ? r : {
                                                            ...r,
                                                            existingVendorAttachmentUrl: "",
                                                            vendor_attachment: null
                                                          }
                                                        )
                                                      }
                                                    )
                                                  }
                                                )
                                              );
                                            }}
                                          >
                                            ⨉
                                          </button>
                                        </div>
                                      ) : (
                                        <div className="uploaded_file_item">
                                          <span className="file_name">{row.vendor_attachment.name}</span>
                                          <button
                                            className="remove_file_btn"
                                            onClick={() =>
                                              handleInputChange(
                                                { target: { value: null } },
                                                vendorIndex,
                                                index,
                                                lineindex,
                                                "vendor_attachment"
                                              )
                                            }
                                          >
                                            ⨉
                                          </button>
                                        </div>
                                      )}
                                      {validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_attachment")] && (
                                        <div className="vendor-error-text">
                                          {validationErrors[getErrorKey(vendorIndex, index, lineindex, "vendor_attachment")]}
                                        </div>
                                      )}
                                    </td> */}

                                    <td className="attachment-cell">
                                      {!row.uploadedFiles || row.uploadedFiles.length === 0 ? (
                                        row.attachment ? (
                                          <div className="attachment_view_section">
                                            <a
                                              href={row.attachment}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="view_link"
                                            >
                                              <i className="fa fa-eye" style={{ marginRight: "5px" }}></i>
                                              <span className="view_text">View</span>
                                            </a>
                                            <button
                                              className="remove_file_btn"
                                              onClick={() => handleRemoveAttachment(vendorIndex, category.id, lineindex)}
                                            >
                                              ⨉
                                            </button>
                                          </div>
                                        ) : (
                                          <label className="file_upload">
                                            <input
                                              type="file"
                                              multiple
                                              onChange={(e) => handleFileUpload(e, vendorIndex, category.id, lineindex)}
                                              style={{ display: "none" }}
                                            />
                                            <img src={upload_icon} alt="Upload" className="upload_icon" />
                                            <span className="upload_text">
                                              Upload{" "}
                                              {row.supporting_document && (
                                                <span style={{ color: "red" }}>(Required*)</span>
                                              )}
                                            </span>
                                          </label>
                                        )
                                      ) : null}

                                      {row.uploadedFiles && row.uploadedFiles.length > 0 && (
                                        <div className="uploaded_files">
                                          {row.uploadedFiles.map((file, fileIndex) => (
                                            <div key={fileIndex} className="uploaded_file_item">
                                              <img
                                                src={
                                                  file.name.endsWith(".xls") || file.name.endsWith(".xlsx")
                                                    ? excel_icon
                                                    : upload_icon
                                                }
                                                alt="File"
                                                className="file_icon"
                                              />
                                              <span className="file_name">{file.name}</span>
                                              <button
                                                className="remove_file_btn"
                                                onClick={() =>
                                                  handleRemoveFile(vendorIndex, category.id, lineindex, fileIndex)
                                                }
                                              >
                                                ⨉
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        position: 'sticky',
                                        right: 0,
                                        background: 'white',
                                        zIndex: 1,
                                        textAlign: 'center',
                                        padding: 0,
                                        boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                      }}
                                    > <button style={{ background: 'white' }} onClick={() => deleteRow(vendorIndex, category.id, lineindex)}>
                                        <img src={delete_icon} alt="Delete" className="delete_icon" />
                                      </button></td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          {/* {category.contract_id == null && ( */}
                          {/* <div className="static-delete-container">
                        {category.rows.map((row, index) => (
                          <div key={index} className="static-delete-btn">
                            <button onClick={() => deleteRow(category.id, index)}>
                              <img src={delete_icon} alt="Delete" className="delete_icon" />
                            </button>
                          </div>
                        ))}
                      </div> */}
                          {/* )} */}
                        </div>

                        {/* {category.contract_id == null && ( */}
                        <div
                          className="add_new_row"
                          onClick={() => addRow(vendorIndex, category.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="add_new_row_popup">
                            <img src={plus_icon} alt="" />
                            Add Row
                          </span>
                        </div>
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}

      </div>
      <CommonFooter />
      {isModalOpen && (
        <VendorInvoicePopup
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          invoices={invoices}
          expandedInvoice={expandedInvoice}
          setExpandedInvoice={setExpandedInvoice}
          popupAction={popupAction}
          invoiceMode={invoiceMode}
          taxInputValue={taxInputValue}
          setTaxInputValue={setTaxInputValue}
          loadTaxCodes={loadTaxCodes}
          updateInvoice={updateInvoice}
          vendorsData={vendorsData}
          setVendorsData={setVendorsData}
          isSaving={isSaving}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
        />
      )}
      <CommonRemarkPopup
        show={showRemarkPopup}
        onClose={() => setShowRemarkPopup(false)}
        onSave={handleSaveRemark}
        initialValue={remarkValue}
        title="Cost Remarks"
      />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  )
}

export default GenerateCostInvoice
